import Marquee from "react-fast-marquee";

const words = ["Body", "Mind", "Soul", "Renewal", "Stillness", "Radiance"];

export const Ribbon = () => (
  <div className="border-y border-[var(--gt-line)] py-10 bg-[var(--gt-surface)]">
    <Marquee speed={26} gradient={false} autoFill>
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-4xl md:text-6xl text-[var(--gt-ivory)] px-16">
            {w}
          </span>
          <span className="text-[var(--gt-gold)] text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
